/* METADATA */
export const DEBUG = false;
export const CODE_SESSION_LENGTH = 6;

/* ALERTE INTERNE « grosse soirée » (boîte noire, spec wiki specs/boite-noire-session.md).
 * Au franchissement de ce nombre de joueurs simultanés, l'écran écrit un doc `alerts`
 * (une fois par session) → email à Victorien via la Cloud Function bigSessionAlert.
 * Rien n'est montré au client (décision 2026-09-08 : ne pas dissuader les grosses
 * soirées). 80 = juste sous le max stable observé (~85) : prévenu AVANT la zone inconnue. */
export const BIG_SESSION_ALERT_PLAYERS = 80;

/* UNBOARED SOCKET SERVER */
export const DEFAULT_SCENE = 'default';
export const DEPLOY_URL = 'unboared.com/join';
export const DEFAULT_CLIENT = 'demo';
// export const PROD_SOCKET_SERVER = 'http://0.0.0.0:5000';
export const PROD_SOCKET_SERVER = 'https://socket-server-v03.herokuapp.com/';
// export const NEXT_SOCKET_SERVER = 'https://wss-js-heroku-v01-f80cd27ccd49.herokuapp.com/'; // ancien host Heroku (compte David)
// export const NEXT_SOCKET_SERVER = 'https://server-socketio-production-7793.up.railway.app/'; // URL Railway brute — bloquée par certains DNS/réseaux (incident du 2026-07-20)
/* Domaine custom pointant sur le MÊME service Railway. Motif : des réseaux
   d'entreprise et des DNS filtrants bloquent `*.up.railway.app` en bloc — les
   téléphones n'atteignaient alors jamais le serveur (session ouverte, zéro join).
   Un domaine maison ne tombe pas dans ces listes. */
export const NEXT_SOCKET_SERVER = 'https://ws.unboared.com/';

/**
 * Socket server selection (progressive rollout of the Node.js server).
 *
 * The Firestore field `clients/{id}.socketServer` holds a TOKEN ('v2'), never
 * a URL: the token also transits in the gamepad QR URL, and resolving it
 * against this whitelist prevents anyone from crafting a QR code that points
 * players to a rogue server. Unknown/absent token = production server.
 */
export const SOCKET_SERVERS: Record<string, string> = {
    v1: PROD_SOCKET_SERVER,
    v2: NEXT_SOCKET_SERVER,
};

export const resolveSocketServer = (token?: string | null): string =>
    (token && SOCKET_SERVERS[token]) || PROD_SOCKET_SERVER;

export const socketServerToken = (token?: string | null): string | undefined =>
    token && SOCKET_SERVERS[token] && token !== 'v1' ? token : undefined;
export const SUPPORT_EMAIL = 'contact@unboared.com';

export const STRIPE_SERVER = 'https://stripe-b2b-fac0fd2b16bc.herokuapp.com';
// export const STRIPE_SERVER = 'http://localhost:4242';
/** Connexion au portail Stripe par email + code (même lien que les emails de fin d'essai). */
export const STRIPE_PORTAL_LOGIN_URL = 'https://billing.stripe.com/p/login/bJe6oH1hYdI7fC6fgGfQI00';

export const SHOW_CONNEXION_INFOS_ON_OPEN = false;

/* ONBOARDING — tutoriel jouable post-inscription (mode anim uniquement).
   Le jeu vit dans le doc Firestore /games/unboarding mais n'est PAS dans la
   liste GAMES ci-dessous : invisible au catalogue, lançable par URL directe. */
export const ONBOARDING_GAME_ID = 'unboarding';
export const ONBOARDING_GAME_ORIGIN = 'https://unboarding.web.app';
/* Action postMessage envoyée par le jeu à la fin du tutoriel
   (contrat : CONSOLE_FINISHED_ACTION côté unboarding). */
export const ONBOARDING_FINISHED_ACTION = 'unboardingFinished';

/* L'ORDRE de cette liste = l'ordre du catalogue sur l'écran (menu TV) : du jeu le
   plus joué au moins joué. Classement figé à la main au 16/10/2026 (fourni par
   Victorien) — pas recalculé automatiquement. Un nouveau jeu se place où on veut
   le voir apparaître. */
export const GAMES = [
    'unblind-test',
    'petit-bac',
    'unquiz',
    'geoloc',
    'draw-guessr',
    'unpop',
    'estim',
    'polyvroom',
    'gloofy-pop',
    'bomber-kitten',
    'footboared',
    // 'eggsit',
    // 'robrawl',
    // 'unport',
];

/* Tri du catalogue selon l'ordre de GAMES ; un jeu hors GAMES (liste propre à un
   client) passe en fin, par nom. */
export function compareGamesCatalogOrder(a: { id: string; name: string }, b: { id: string; name: string }) {
    const rank = (id: string) => {
        const i = GAMES.indexOf(id);
        return i < 0 ? GAMES.length : i;
    };
    return rank(a.id) - rank(b.id) || a.name.localeCompare(b.name);
}

/* UNBOARED AIPORT CONFIGS */

/* Jeux retirés du mode aéroport free-play : format/contenu inadapté à un usage
   libre-service dans un lieu public (Blind Test = musique qui coupe + catalogue
   limité ; Unquizz = quiz long, pensé pour être animé). */
export const FREEPLAY_EXCLUDED_GAME_IDS = ['unblind-test', 'unquiz'];

/* Catalogue choisissable par les passagers en mode aéroport free-play.
   = GAMES moins les jeux exclus → un nouveau jeu ajouté à GAMES y apparaît
   automatiquement. DISTINCT de RANDOM_GAME_IDS, qui ne gouverne que la rotation
   AUTO (un sous-ensemble plus restreint, ex. unpop hors rotation auto mais
   choisissable manuellement). */
export const FREEPLAY_GAME_IDS = GAMES.filter((id) => !FREEPLAY_EXCLUDED_GAME_IDS.includes(id));

export const RANDOM_GAME_IDS = [
    'bomber-kitten',
    'gloofy-pop',
    'geoloc',
    'petit-bac',
    'footboared',
    // 'eggsit',
    // 'polyvroom',
    // 'robrawl',
    // 'unport',
];
/**
 * Clients dont l'écran ET la manette ont une charte propre : couleurs et logo
 * chargés depuis `public/assets/css/{clientID}.css`, par-dessus les `:root` de
 * index.css. **Ajouter l'ID ici en même temps que le fichier**, sinon la charte
 * ne part pas.
 *
 * Liste explicite plutôt qu'injection pour tout le monde : un `<link>` vers un
 * fichier absent, c'est un 404 de plus à chaque chargement — sur le téléphone du
 * joueur pour la manette — chez les ~1000 établissements sans charte (gotcha #152).
 */
export const CLIENT_THEME_CSS = ['airport-ORY'];

export const TIME_AFTER_NO_GAMEPAD_IN_MS = 60 /* sec */ * 1000;
export const CHANGE_GAME_TIMEOUT_IN_MS = 20 /* min */ * 60 /* sec */ * 1000;
